import ReactGA from 'react-ga';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { GOOGLE_ANALYTICS_ID } from '../environment';
import { ActionType, CategoryType } from '../../types/analytics/enum';

const initializeReactGA = () => {
  GOOGLE_ANALYTICS_ID && ReactGA.initialize(GOOGLE_ANALYTICS_ID);
};

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    initializeReactGA();
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);
};

export const sendAnalyticsPath = (path: any) => {
  initializeReactGA();

  ReactGA.pageview(path);
};

export const sendAnalyticsEvent = (
  category: CategoryType,
  action: ActionType,
) => {
  initializeReactGA();

  ReactGA.event({ category, action });
  ReactGA.ga('send', {
    hitType: 'event',
    eventCategory: category,
    eventAction: action,
  });
};
